export const blockIconsMapsWestNew = (
	<span className='material-symbols-outlined'>west</span>
);
